<template>
  <div>
    <el-button type="danger" size="mini" :disabled="isDelete" @click="deleteList" v-if="!readonly" style="float:right;margin:10px 15px 10px 0;">删除</el-button>
    <el-table ref="list" @selection-change="handleSelectionChange" border :data="tableData" style="width: 100%" @row-click="rowClick"  show-summary  :summary-method="getSummaries">
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="GoodsCode" label="条码">
        <template slot-scope="{ row }">
          <span>{{row.GoodsCode}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
            <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
            <template slot-scope="{ row }" >
              <account-select
                v-if="!readonly && info.CustomerId"
                v-model="row.GoodsName"
                :source="DAccount"
                @select="onSelect($event,row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal='listTotal'
                @currentPage="currentPage($event, row)"
                @click.native="resetFun"
                @inputText="inputText($event, row)"
                :pageType='true'
              />
              <span v-else>{{info.CustomerId?row.GoodsName:'请先选择客户'}}</span>
            </template>
          </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="Quantity1" label="辅单位数量1" width="90px">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Quantity1"
            type="number"
            @input="changeNum(row)"
            @blur="onBlur(row,'Quantity1')"
            @focus="onFocus(row,'Quantity1')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId1" label="辅单位1">
          <template slot-scope="{ row }">
              <el-select
                v-if="row.Units && row.Units.length"
                size="mini"
                v-model="row.UnitId1"
                :placeholder="readonly?'':'请选择'"
                :disabled="readonly"
                @change="unitChange(row,'1')"
              >
                <el-option v-for="(item,index) in row.Units" :key='index' :label="item.UnitName" :value="item.UnitId"></el-option>
              </el-select>
          </template>
      </el-table-column>
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Offer"
            type="number"
            @blur="onBlur(row,'Offer')"
            @focus="onFocus(row,'Offer')"
            @input="rateChange(row)"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{$commonJs.getThousandNum(row.Offer)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.Price)}}
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.NoTaxAmount)}}
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" width="150px">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" v-if="!readonly"></el-input>
          <span v-else>{{row.Remark}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="主单位数量" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId" label="主单位">
          <template slot-scope="{ row }">
              <el-select
                v-if="row.Units && row.Units.length"
                size="mini"
                v-model="row.UnitId"
                :placeholder="readonly?'':'请选择'"
                :disabled="true"
              >
                <el-option v-for="(item,index) in row.Units" :key='index' :label="item.UnitName" :value="item.UnitId"></el-option>
              </el-select>
          </template>
      </el-table-column>
      
      <el-table-column prop="Quantity2" label="辅单位数量2" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId2" label="辅单位2">
          <template slot-scope="{ row }">
              <el-select
                v-if="row.Units && row.Units.length"
                size="mini"
                v-model="row.UnitId2"
                :placeholder="readonly?'':'请选择'"
                :disabled="readonly"
                @change="unitChange(row,'2')"
              >
                <el-option v-for="(item,index) in row.Units" :key='index' :label="item.UnitName" :value="item.UnitId"></el-option>
              </el-select>
          </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " />
      
      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input v-model="row.Discount" type="number" @input="disChange(row)" @blur="onBlur(row,'Discount')"  @focus="onFocus(row,'Discount')" v-if="!readonly"></el-input>
          <span v-else>{{row.Discount}}</span>
        </template>
      </el-table-column>
    
      <el-table-column prop="TaxRate" label="税率/%">
        <template slot-scope="{ row }">
          <el-input v-model="row.TaxRate" type="number" @input="rateChange(row)" @blur="onBlur(row,'TaxRate')"  @focus="onFocus(row,'TaxRate')" v-if="!readonly"></el-input>
          <span v-else>{{row.TaxRate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.TaxAmount)}}
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.Amount)}}
        </template>
      </el-table-column>
      
      <!-- <el-table-column prop="PromotionType" label="参与活动" width="100px">
        <template slot-scope="{ row }">
              <el-select
                size="mini"
                v-model="row.PromotionType"
                placeholder="请选择"
                clearable
                v-if="!readonly"
              >
                <el-option label="团购" :value="0"></el-option>
                <el-option label="秒杀" :value="1"></el-option>
                <el-option label="折扣" :value="2"></el-option>
              </el-select>
               <span v-else>{{row.PromotionType==0?'团购':row.PromotionType==1?"秒杀":row.PromotionType==2?"折扣%":""}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="ReferenceCost" label="预估成本单价" width="110px">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.ReferenceCost)}}
        </template>
      </el-table-column>
      <el-table-column prop="GrossProfit" label="毛利">
        <template slot-scope="{ row }">
          {{$commonJs.getThousandNum(row.GrossProfit)}}
        </template>
      </el-table-column>
     
      <el-table-column label="操作" align="center" fixed="right" width="130px">
        <template slot-scope="{ row,$index }">
          <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click.stop="copy(row,$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click.stop="del(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
import accountSelect from "@/components/sales/business/select";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    showTax: {
      type: Number,
      default: 0,
    }
  },
  components: {
    goodsDialog,
    accountSelect
  },
  data() {
    return {
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [
        {
              T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: ""
        }
      ],
      tableDel: [],
      multi: require("@/api/goods/multiUnit").default,
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/sale/sales").default,
      account_api: require("@/api/mall/mallgoods").default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount:[],
      initTotal:0,
      delList: [],
    };
  },
  watch:{
    "info.CustomerId":{
      handler:function(){
      this.account_api.sellGoods({ Status: 1,pageIndex:1,pageSize:7,TradeUnitId:this.info.CustomerId }).then((res) => {
          if (res.Code == 0) this.DAccount = res.Data,this.initDAccount=res.Data,this.initTotal=res.Count;
        });
      }
    },
  },
  mounted() {
    // this.account_api.sellGoods({ Status: 1,pageIndex:1,pageSize:7 }).then((res) => {
    //   if (res.Code == 0) this.DAccount = res.Data,this.initDAccount=res.Data,this.initTotal=res.Count;
    // });
  },
  computed: {
    isDelete(){
      return this.delList.length === 0;
    }
  },
  methods: {
    delListOfIndex(id){

      return this.tableData.findIndex(item => {
        return id === item.GoodsId;
      })


    },
    deleteList(){
      
      this.delList.forEach(item => {
        if(item.T !== 0){
          item.T = 2;
          this.tableDel.push(item)
        }
      })

      
      let GoodsIds = this.delList.map(item => {
        return item.GoodsId
      })
      let GoodsIdsLength = GoodsIds.length;
      for(let i = 0; i < GoodsIdsLength; ++i){
        let index = this.delListOfIndex(GoodsIds[i]);
        this.tableData.splice(index, 1);
      }

      this.delList = [];

      this.subTable();
      
    },
    handleSelectionChange(list){
      this.delList = list;
    },
    unitChange(row,name){
      console.log(row)
      row.Units.forEach(e=>{
        if(e.UnitId==row['UnitId'+name]){
          row['Rate'+name]=e.Rate
        }
      })
      this.count(row);
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    resetFun(){
       this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage(val, row){
          let GoodsName = row.GoodsName;
          this.pageParams.pageIndex=val
          this.account_api.sellGoods({ Status: 1,pageIndex: val,pageSize:7,TradeUnitId:this.info.CustomerId, GoodsName }).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    inputText(text, row){
      if (text == row.GoodsName) {
        //console.log("相同", text);
        return;
      }
       row.GoodsName = text;
       this.account_api.sellGoods({ Status: 1,pageIndex:1,pageSize:7 ,GoodsName:text,TradeUnitId:this.info.CustomerId}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    getDataFromOrder(id) {
      this.saleApi.getGoodsList(id).then((res) => {
        this.tableData.forEach(item => {
          if(item.T !== 0) {
            item.T = 2
            this.tableDel.push(item)
          }
        })
        res.Data.forEach(item => {
          item.T = 0;
          item.OrderGoodsId = 0;
          // item.OrderId = 0;
          // item.DocGoodsId = 0;
          // item.DocId = this.info.DocId || 0;
          // item.OrderGoodsId = 0;
          // item.OrderId = 0;
          // item.AddTime = this.info.DocDate || today;
          // item.WarehouseId = null
          // this.count(item,true)
          this.multi.list({GoodsId:item.GoodsId}).then((res) => {
            item.Units=res.Data
            res.Data.forEach(e=>{
              if(e.IsMain){
                item.UnitId=e.UnitId
                item.UnitId1=e.UnitId
                item.Rate1=e.Rate
              }
              if(item.UnitId2==e.UnitId){
                item.Rate2=e.Rate
              }
            })
             this.count(item,true)
          });
        })
        this.tableData = res.Data;
        // this.tableData.forEach(x=>{
        //   this.count(x)
        // })
      });
    },
validateCounts(row,index, e,name) {
      
    e.target.blur() // 或者this.$refs[row.id].blur()
     this.$refs[Object.keys(this.$refs)[index + 1]+name].focus();
    },
    getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 5 || index === 9|| index === 11|| index === 13|| index === 19|| index === 20|| index === 21|| index === 22) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor( (prev + curr)*100 )/100;
              } else {
                return Math.floor(prev*100)/100;
              }
            }, 0);
            if(index!=4){
               sums[index] = this.$commonJs.getThousandNum(sums[index]);
            }else{
               sums[index] = sums[index]
            }
          }
          return;
        }
      });
      return sums;
    },
    rowClick(row) {
      if(!this.readonly){
          var index = this.$refs.list.data.indexOf(row);
          if (index + 1 == this.$refs.list.data.length) {
            // 
            this.addGoods();
          }
      }
    },
        onSelect(e, row) {
          
          // this.setGoods(e,row)
      row.T = row.T == 0 ? 0 : 1;
      // row.AccountId = e.AccountId;
      // row.GoodsName = e.GoodsName;
          row.OrderGoodsId= 0
          row.OrderId= this.info.OrderId || 0
          row.BarCode= e.BarCode
          row.GoodsName= e.GoodsName
          row.GoodsId= e.GoodsId
          row.Model= e.Model || ""
          row.UnitId= e.UnitId || 0
          row.UnitName= e.MainUnitName || ""
          row.Quantity = 0;
          row.Quantity1 = 0;
          row.Quantity2 = 0;
          row.BatchNo= e.BatchNo || ""
          row.Offer= e.WholesalerPrice || e.RetailPrice|| 0
          row.Discount= 100
          row.Price=e.WholesalerPrice || e.RetailPrice||0
          row.ExistQuantity= e.ExistQuantity || 0
          row.AvailableQuantity= e.AvailableQuantity || 0
          row.TaxRate= 0
          row.TaxAmount= 0
          row.Amount= 0
          row.NoTaxAmount= 0
          row.PromotionType= 0
          row.PromotionId= 0
          row.ReferenceCost= e.ReferenceCost || 0
          row.GrossProfit= 0
          row.Remark= e.Remark || ""
          row.Thumbnail= ""
          row.OutQuantity= 0
          row.AddTime= this.info.DocDate || today
          this.multi.list({GoodsId:e.GoodsId}).then((res) => {
            row.Units=res.Data
            res.Data.forEach(e=>{
              if(e.IsMain){
                row.UnitId=e.UnitId
                row.UnitId1=e.UnitId
                row.Rate1=e.Rate
              }
              if(row.UnitId2==e.UnitId){
                row.Rate2=e.Rate
              }
            })
          });
        
    },
    getData() {
      this.info.Goods.forEach(e=>{
        if(e.UnitId==0){
          e.UnitId=null
        }
        if(e.UnitId1==0){
          e.UnitId1=null
        }
        if(e.UnitId2==0){
          e.UnitId2=null
        }
        e.T=null
        e.Units.forEach(v=>{
          if(e.UnitId1==v.UnitId){
             e.Rate1=v.Rate
          }
          if(e.UnitId2==v.UnitId){
             e.Rate2=v.Rate
          }
        })
      })
      this.tableData=this.info.Goods
      // this.tableData = []
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row,index) {
      
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          if(this.tableData.length==1){
            this.tableData.splice(index, 1);
            this.addGoods();
          }else{
            this.tableData.splice(index, 1);
          }
          this.subTable()
        })
    },
    copy(row,index) {
        this.tableData.splice(index,0,{
          ...row
        })
        this.tableData[index].OrderGoodsId = 0
        this.tableData[index].T = 0
        this.subTable()
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
            let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          Quantity1:0,
          Quantity2:0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          UnitId:"",
          UnitId1:"",
          UnitId2:""
        }
        this.tableData.push(goods)
    },
    setGoods(e,row) {
      let date = new Date()
      let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
      this.sApi.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate }).then(res => {
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || "",
          UnitId: e.UnitId || 0,
          UnitName: e.MainUnitName || "",
          Quantity: 0,
          BatchNo: e.BatchNo || "",
          Offer: e.WholesalePrice || 0,
          Discount: 100,
          Price:e.WholesalePrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: this.info.DocDate || today
        }
        if(res.Data != null) {
          goods.Offer = res.Data.VirtualPrice
        }
        this.tableData.push(goods)
      })
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)
      this.count(row)
    },
    rateChange(row) {
      this.count(row)
    },
    disChange(row) {
      this.count(row)
    },
    count(row) {
      let price = row.Price?Number(row.Price):0
      let dis = row.Discount>0?Number(row.Discount):100
      let qua = row.Quantity1?Number(row.Quantity1):0
      let rate = row.TaxRate?Number(row.TaxRate):0
      let ref = row.ReferenceCost?Number(row.ReferenceCost):0
      if(row.T !== 0) {
        row.T = 1
      }
      row.Price = dis  ? (row.Offer * (dis/100) * (1 + rate / 100)).toFixed(2) : (row.Offer * (1 + rate / 100)).toFixed(2);
      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2);
      row.NoTaxAmount = ((row.Offer * (dis/100))*row.Quantity1).toFixed(2)
      row.TaxAmount = (((qua * (((dis ? row.Offer * (dis/100) : row.Offer) * rate)/100)) * 100) / 100).toFixed(2) || 0;
      row.GrossProfit = (row.Amount - (qua * ref)).toFixed(2)
      row.Quantity=(1/row.Rate1)*qua
      if(row.UnitId2==row.UnitId){
        row.Quantity2=row.Quantity
      }else{
          console.log(row.Rate2,row.Quantity)
        if(!row.Rate2){
          row.Quantity2=0
        }else{
          row.Quantity2=row.Rate2*row.Quantity
        }
      }
      this.subTable()
    },
    subTable() {
      this.$emit("getList",this.tableData.concat(this.tableDel))
    },
  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
</style>